import React,{ PureComponent} from 'react';
import $ from 'jquery';
//import utils from 'common/js/utils';
import './Nav.scss';
import immutable from 'immutable';

export default class Nav extends PureComponent {
    constructor(props){
        super(props);
        this.centerX = document.documentElement.clientWidth / 2;//中间位置
        this.offsetLeftCache = {};
        this.gId =  props.gId;//当前选择的分类id
        this.state = {
            tId: 0,//当前选择的标签id
            tags: []
        };

        this.scroll = this.scroll.bind(this);
        this.getTags = this.getTags.bind(this);
        this.changeType = this.changeType.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);

        this.addEvent = this.addEvent.bind(this);
        this.removeEvent = this.removeEvent.bind(this);
    }
    componentDidMount(){
        this.scroll(1, this.gId, 'init');
        this.getTags(this.gId);

        this.addEvent();
    }
    componentWillUnMount() {
        this.removeEvent();
    }


    addEvent(){
        for( var i = 1;  i < 3; i++){
            this.refs['nav'+ i].addEventListener('touchstart', this.handleTouchStart , false);
            this.refs['nav'+ i].addEventListener('touchend',this.handleTouchEnd , false);
        }
    }
    removeEvent(){
        for( var i = 1;  i < 3; i++){
            this.refs['nav'+ i].removeEventListener('touchstart', this.handleTouchStart);
            this.refs['nav'+ i].removeEventListener('touchend',this.handleTouchEnd);
        }
    }
    /**
     * 获取分类下的全部表情 1次setState
     */
    getTags( gId ){ 

        this.props.list.map((item ,index) =>{
            if(item.get('gid') == gId){
                let subList = item.get('subList');
                this.setState({
                    tags: subList
                });
                if(subList.size > 0){
                    let tagId = subList.get(0).get('tagId');
                    let gId = subList.get(0).get('gid');
                    this.setState({
                        tId: tagId
                    });
                    this.props.handleMoreTags();
                    this.props.changeTag(gId, tagId);
                }
                return;
            }
        })

        
    }
    /**
     * 切换类别
     */
    changeType(gId, tId, index){
        if( gId == this.gId ){
            return;
        }
        this.gId = gId;
        this.scroll(1, gId);

        //如果有子标签就不去请求数据
        let subList = this.props.list.get(index).get('subList');
        // if(subList.size > 0){
        //     this.props.changeType(gId, tId , false);
        //     this.getTags(gId);
        // }
        let isGetData = subList.size > 0 ? false : true;
        this.props.changeType(gId, tId ,isGetData);
        this.getTags(gId);
        
    }
    /**
     * 切换标签
     */
    changeTag(gId, tId){
        if( tId == this.state.tId ){
            return;
        }
        this.setState({
            tId: tId
        });
        this.scroll(2, tId);
        this.props.changeTag(gId, tId);
    }
    scroll( navIndex, gId ,from ){
        const navWrapId = "nav" + navIndex;
        const navId = navWrapId + "_"+ gId;

        var offSetLeft = this.offsetLeftCache[navId];
        var dom = this.refs[ navId ];

        if( !offSetLeft && dom ){
            offSetLeft = this.offsetLeftCache[navId] = dom.offsetLeft - this.centerX;
        }
        if( from === 'init' ){
            this.refs[navWrapId].scrollLeft = offSetLeft;
        }else{
            $(this.refs[navWrapId]).animate({scrollLeft: offSetLeft}, 200, 'swing');
        }

    }
    handleTouchStart(event){
        event = event || window.event;
        this.startX = event.touches[0].pageX  &  event.changedTouches[0].pageX  &  event.targetTouches[0].pageX ;

    }
    handleTouchEnd(event){
        event = event || window.event;
        this.endX =  (event.changedTouches[0] && ( event.changedTouches[0].pageX  &  event.changedTouches[0].pageX  &  event.changedTouches[0].pageX)) || this.startX ;
        if( Math.abs(this.endX - this.startX) < 10 ){
            
            const {gid, tid, index} = event.target.dataset;
            
            if( index ){
                this.changeType( gid, tid, index );
            }else{
                this.changeTag( gid, tid );
            }

        }
    }
    render() {
        var gId = this.props.gId;
        return (
            <div className="m-index-nav-wrap">
                <ul className="m-index-nav"  ref="nav1">
                    {this.props.list.map((item, index) =>
                       <li
                           ref={"nav1_"+item.get("gid")}
                           key={item.get("id")+''}
                           data-index={index}
                           data-gid={+item.get("gid")}
                           data-tid={+item.get("tagId")}
                           className={"nav " + (gId == +item.get("gid") ? 'cur' : '')}
                       >
	                       {item.get("name")}

                       </li>
                    )}
                </ul>
                <ul className="m-index-nav sub"  ref="nav2">
                        {this.state.tags.map((item, index) =>
                            <li
                                ref={"nav2_" + item.get("tagId")}
                                key={item.get("id")+''}
                                data-gid={+item.get("gid")}
                                data-tid={+item.get("tagId")}
                                className={"nav " + (this.state.tId == +item.get("tagId") ? 'cur' : '')}
                            >
                                {item.get("name")}
                            </li>
                        )}
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/index/nav/Nav.jsx